import { apiRequest } from '../client'
import type { StockKind } from '../types'

export type InventoryViewItem = {
  sku: string
  name: string
  availableQty?: number
  reservedQty: number
  safetyBufferQty?: number
  /**
   * What today's announced, unbooked, switched-on deliveries add for this SKU
   * (CHG-2026-09-announced-deliveries). Absent for a backend that predates the change.
   */
  incomingQty?: number
  /**
   * Server-computed sellable (inventory_sellable view, V140) — the same figure the shop and the
   * menu planner show, correct even for a SKU that has no inventory row yet. Absent for a
   * backend that predates the change.
   */
  sellableQty?: number
  /** CHG-2026-09-stock-usage-and-price-twins: the base unit as shown ("Stk" by default). */
  stockUnit?: string
  /**
   * "Teilmengen zählen": corrections of this article accept up to 3 decimals (phase B4, on every
   * row). Absent only on a backend that predates it.
   */
  fractionalCounting?: boolean
  /**
   * CHG-2026-09-stock-usage-and-price-twins (task 7.5): present on derived rows only (dish,
   * variant, not-tracked article) with their online availability and the limiting part.
   * Quantities are decimal numbers (up to 3 decimals) in the base unit.
   */
  stockKind?: StockKind
  unlimited?: boolean
  onlineQty?: number
  limitingSku?: string
  limitingName?: string
  updatedAt?: string
}

export const inventoryViewApi = {
  list: (params: {
    restaurantId: number
    search?: string
    categoryCode?: string
    onlyOnMenu?: boolean
    onlyInPosLayout?: boolean
    onlyRecentMovements?: boolean
    /** Only SKUs with an announced incoming quantity today. */
    onlyIncoming?: boolean
    at?: string
    includeUnassigned?: boolean
    /** CHG-2026-09-stock-usage-and-price-twins (task 7.5): only rows of this kind. */
    stockKind?: StockKind
    page?: number
    pageSize?: number
    sortBy?: string
    sortDir?: 'asc' | 'desc'
  }) => {
    const sp = new URLSearchParams()
    sp.set('restaurantId', String(params.restaurantId))
    if (params.search) sp.set('search', params.search)
    if (params.categoryCode) sp.set('categoryCode', params.categoryCode)
    if (params.onlyOnMenu) sp.set('onlyOnMenu', 'true')
    if (params.onlyInPosLayout) sp.set('onlyInPosLayout', 'true')
    if (params.onlyRecentMovements) sp.set('onlyRecentMovements', 'true')
    if (params.onlyIncoming) sp.set('onlyIncoming', 'true')
    if (params.at) sp.set('at', params.at)
    if (params.includeUnassigned) sp.set('includeUnassigned', 'true')
    if (params.stockKind) sp.set('stockKind', params.stockKind)
    if (params.page != null) sp.set('page', String(params.page))
    if (params.pageSize != null) sp.set('pageSize', String(params.pageSize))
    if (params.sortBy) sp.set('sortBy', params.sortBy)
    if (params.sortDir) sp.set('sortDir', params.sortDir)
    return apiRequest<{
      items: Array<InventoryViewItem>
      total: number
      page: number
      pageSize: number
    }>(`/api/v0/admin/inventory?${sp.toString()}`)
  },
}
